import React from "react";
import Skeleton from "react-loading-skeleton";

export const DocumentsLoader = () => {
  return (
    <>
      <div className="row g-3">
        {Array(6)
          .fill(0)
          .map((i) => (
            <div className="col-sm-12 col-md-12 col-lg-6">
              <Skeleton height={160} />
              <Skeleton height={25} />
            </div>
          ))}
      </div>
    </>
  );
};
